export default "__VITE_ASSET__Blz4yS2___"